import { render, staticRenderFns } from "./TeamsListView.vue?vue&type=template&id=1264e040"
import script from "./TeamsListView.vue?vue&type=script&lang=js"
export * from "./TeamsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports